import { MouseEventHandler } from 'react';
import { usePhoneCallAction } from '@frontend/contact-actions-place-call';
import { useQuickFillAction } from '@frontend/contact-actions-quickfill';
import { ReviewActionHooks } from '@frontend/contact-actions-review-invitation';
import { useMessageAction } from '@frontend/contact-actions-send-message';
import { useContactPanelShallowStore } from '@frontend/shared';

export const dialUrl = `/desktop/v1/phones/dial`;
export const endUrl = `/desktop/v1/phones/end`;
export const holdUrl = `/desktop/v1/phones/hold`;
export const resumeUrl = `/desktop/v1/phones/resume`;

type Action = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const useViewAction = (personId?: string): Action => {
  const { setPersonId } = useContactPanelShallowStore('setPersonId');

  return {
    onClick: () => {
      if (personId) {
        setPersonId(personId);
      }
    },
  };
};

export const actions = {
  usePhoneCallAction,
  useQuickFillAction,
  useMessageAction,
  useViewAction,
  useReviewAction: ReviewActionHooks.useReviewAction,
};
